var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 48,
    viewBox: "0 0 19 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53166 4L12.3077 4.048C12.5743 4.048 12.809 4.14933 13.0117 4.352L17.0597 8.464C17.2517 8.656 17.3477 8.896 17.3477 9.184L17.2997 14.96C17.2997 15.2267 17.1983 15.4613 16.9957 15.664L12.8837 19.712C12.6917 19.904 12.4517 20 12.1637 20L6.38766 19.952C6.12099 19.952 5.88632 19.8507 5.68366 19.648L1.63566 15.536C1.44366 15.344 1.34766 15.104 1.34766 14.816L1.39566 9.04C1.39566 8.77333 1.49699 8.53867 1.69966 8.336L5.81166 4.288C6.00366 4.096 6.24366 4 6.53166 4ZM12.0517 8.544L9.34766 11.232L6.64366 8.544L5.89166 9.296L8.57966 12L5.89166 14.704L6.64366 15.456L9.34766 12.768L12.0517 15.456L12.8037 14.704L10.1157 12L12.8037 9.296L12.0517 8.544Z",
    fill: "#C52A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4d6c57b2ae6b183ccaf4cd5b6911f40d.svg";
export { ForwardRef as ReactComponent };